export const ADDITIONAL_AREA = Object.freeze({
  LABEL: 'additional.additional',
})
